import Model from '../../ModelBinding/Model';
import InvoiceCollection from './InvoiceCollection';
import PaymentCollection from "../Payment/PaymentCollection";
import dayjs from 'dayjs';

export default class Invoice extends Model {
  public status?: string;
  public due_date?: dayjs.Dayjs;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;
  public payments?: PaymentCollection;
  public connection_id?: string;
  public connection_name?: string;
  public connection_url?: string;

  bind() {
    this.status = this.getStringAttribute('status');
    this.due_date = this.getDateAttribute('due_date');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
    this.connection_id = this.getStringAttribute('connection_id');
    this.connection_name = this.getStringAttribute('connection_name');
    this.connection_url = this.getStringAttribute('connection_url');
    this.payments = this.getRelationCollection('payments', PaymentCollection) as PaymentCollection;
  }

  static getCollection() {
    return InvoiceCollection;
  }
}
